(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  class CartPage {
    constructor() {
      this.init();
    }

    init() {
      this.bindEvents();
    }

    bindEvents() {
      document.addEventListener('click', (e) => {
        const plusBtn = e.target.closest('[data-quantity-plus]');
        if (plusBtn) {
          this.updateQuantity(plusBtn.dataset.itemKey, 1);
        }
        const minusBtn = e.target.closest('[data-quantity-minus]');
        if (minusBtn) {
          this.updateQuantity(minusBtn.dataset.itemKey, -1);
        }
        const removeBtn = e.target.closest('[data-remove-item]');
        if (removeBtn) {
          this.removeItem(removeBtn.dataset.itemKey);
        }
      });

      const shippingForm = document.getElementById('shipping-calculator');
      if (shippingForm) {
        shippingForm.addEventListener('submit', (e) => {
          e.preventDefault();
          this.calculateShipping();
        });
      }
    }

    async updateQuantity(itemKey, change) {
      try {
        const cartResponse = await fetch('/cart.js');
        const currentCart = await cartResponse.json();
        
        const item = currentCart.items.find(item => item.key === itemKey);
        if (!item) return;
        
        const newQuantity = Math.max(0, item.quantity + change);
        const updates = {};
        updates[itemKey] = newQuantity;
        
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ updates })
        });

        if (response.ok) {
          const cart = await response.json();
          this.updateCartDisplay(cart);
        } else {
          console.error('Cart update failed:', response.status, response.statusText);
        }
      } catch (error) {
        console.error('Error updating cart:', error);
      }
    }

    async removeItem(itemKey) {
      try {
        const updates = {};
        updates[itemKey] = 0;
        
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ updates })
        });

        if (response.ok) {
          const cart = await response.json();
          this.updateCartDisplay(cart);
        } else {
          console.error('Cart remove failed:', response.status, response.statusText);
        }
      } catch (error) {
        console.error('Error removing item:', error);
      }
    }

    updateCartDisplay(cart) {
      // Update cart count in header if it exists
      const cartCount = document.querySelector('.nav__cart-count');
      if (cartCount) {
        if (cart.item_count > 0) {
          cartCount.textContent = cart.item_count;
          cartCount.style.display = 'flex';
        } else {
          cartCount.style.display = 'none';
        }
      }

      // Update cart items display
      const cartForm = document.getElementById('cart-form');
      if (cartForm) {
        if (cart.item_count > 0) {
          cartForm.innerHTML = this.renderCartItems(cart.items);
        } else {
          window.location.href = '/cart';
        }
      } else {
        const cartItemsContainer = document.querySelector('.cart-page__items');
        if (cartItemsContainer) {
          if (cart.item_count > 0) {
            cartItemsContainer.innerHTML = this.renderCartItems(cart.items);
          } else {
            window.location.href = '/cart';
          }
        }
      }

      // Update cart summary
      this.updateCartSummary(cart);
    }

    escapeHTML(value) {
      if (value == null) return '';
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    renderCartItems(items) {
      const esc = (v) => this.escapeHTML(v);
      const removeLabel = (window.theme && window.theme.cartStrings && window.theme.cartStrings.remove) || 'Remove item';
      return items.map((item) => {
        const variantBlock = item.variant_title && item.variant_title !== 'Default Title'
          ? `<p class="cart-item__variant">${esc(item.variant_title)}</p>`
          : '';
        const imageBlock = item.image
          ? `<img src="${esc(item.image)}" alt="${esc(item.product_title)}" width="120" height="120" loading="lazy">`
          : `<div class="cart-item__placeholder">
              <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true" focusable="false">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                <circle cx="8.5" cy="8.5" r="1.5"></circle>
                <polyline points="21,15 16,10 5,21"></polyline>
              </svg>
            </div>`;
        return `
          <div class="cart-item" data-item-key="${esc(item.key)}">
            <div class="cart-item__image">
              <a href="${esc(item.url)}">${imageBlock}</a>
            </div>

            <div class="cart-item__details">
              <div class="cart-item__info">
                <h3 class="cart-item__title">
                  <a href="${esc(item.url)}">${esc(item.product_title)}</a>
                </h3>
                ${variantBlock}
                <div class="cart-item__price-quantity">
                  <p class="cart-item__price">${esc(this.formatMoney(item.final_line_price))}</p>
                  <div class="cart-item__quantity">
                    <button type="button" class="quantity-btn quantity-btn--minus" data-quantity-minus data-item-key="${esc(item.key)}">-</button>
                    <input type="number" name="updates[]" value="${esc(item.quantity)}" min="0" class="quantity-input" data-item-key="${esc(item.key)}">
                    <button type="button" class="quantity-btn quantity-btn--plus" data-quantity-plus data-item-key="${esc(item.key)}">+</button>
                  </div>
                </div>
              </div>

              <div class="cart-item__actions">
                <button type="button" class="cart-item__remove" data-remove-item data-item-key="${esc(item.key)}" aria-label="${esc(removeLabel)}">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        `;
      }).join('');
    }

    updateCartSummary(cart) {
      // Update subtotal
      const subtotalElement = document.querySelector('.cart-summary__row:first-child span:last-child');
      if (subtotalElement) {
        subtotalElement.textContent = this.formatMoney(cart.items_subtotal_price);
      }

      // Update total
      const totalElement = document.querySelector('.cart-summary__row--total span:last-child');
      if (totalElement) {
        totalElement.textContent = this.formatMoney(cart.total_price);
      }

      // Update discount if exists
      const discountRow = document.querySelector('.cart-summary__row--discount');
      if (cart.total_discount > 0) {
        if (!discountRow) {
          // Add discount row if it doesn't exist
          const subtotalRow = document.querySelector('.cart-summary__row:first-child');
          if (subtotalRow) {
            const discountHTML = `
              <div class="cart-summary__row cart-summary__row--discount">
                <span>${(window.theme && window.theme.cartStrings && window.theme.cartStrings.discount) || 'Discount'}</span>
                <span>-${this.formatMoney(cart.total_discount)}</span>
              </div>
            `;
            subtotalRow.insertAdjacentHTML('afterend', discountHTML);
          }
        } else {
          // Update existing discount row
          const discountAmount = discountRow.querySelector('span:last-child');
          if (discountAmount) {
            discountAmount.textContent = `-${this.formatMoney(cart.total_discount)}`;
          }
        }
      } else if (discountRow) {
        // Remove discount row if no discount
        discountRow.remove();
      }
    }

    formatMoney(cents) {
      const currency = (window.theme && window.theme.cart && window.theme.cart.currency) || 'USD';
      const locale = (window.theme && window.theme.cart && window.theme.cart.locale) || 'en';
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2) + ' ' + currency;
      }
    }

    calculateShipping() {
      const country = document.getElementById('shipping-country').value;
      const zip = document.getElementById('shipping-zip').value;
      const resultsContainer = document.getElementById('shipping-results');
      const optionsContainer = document.getElementById('shipping-options');

      if (!country || !zip) {
        alert('Please select a country and enter a ZIP code');
        return;
      }

      const mockShippingOptions = [
        { name: 'Standard Shipping', price: '$5.99', time: '5-7 business days' },
        { name: 'Express Shipping', price: '$12.99', time: '2-3 business days' },
        { name: 'Overnight Shipping', price: '$24.99', time: '1 business day' }
      ];

      optionsContainer.innerHTML = mockShippingOptions.map(option => `
        <div class="shipping-option">
          <div class="shipping-option__name">
            <div>${option.name}</div>
            <small>${option.time}</small>
          </div>
          <div class="shipping-option__price">${option.price}</div>
        </div>
      `).join('');

      resultsContainer.style.display = 'block';
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    new CartPage();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-account"]) return;
  try {
    
  // Per-view init: binds form handler to the current birthdate form. Runs on
  // initial DOM ready and on every Swup page:view (DOMContentLoaded only
  // fires once for the document lifetime, so it can't be used alone here).
  function initBirthdateForm() {
    const form = document.getElementById('birthdate-form');
    const msg = document.getElementById('birthdate-msg');
    form?.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!form) return;
      if (msg) msg.textContent = 'Saving…';
      try {
        const res = await fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: { 'Accept': 'application/json' }
        });
        const data = await res.json().catch(() => ({}));
        if (msg) msg.textContent = (res.ok && data.ok) ? 'Saved ✓' : ('Error: ' + (data.error || res.status));
      } catch (err) {
        if (msg) msg.textContent = 'Network error';
      }
    });
  }


  window.switchTab = function(tabName) {
    // Hide all tab contents
    const tabs = document.querySelectorAll('.customer-account__tab-content');
    tabs.forEach(tab => {
      tab.style.display = 'none';
    });

    // Remove active class from all nav items
    const navItems = document.querySelectorAll('.customer-account__nav-item');
    navItems.forEach(item => {
      item.classList.remove('customer-account__nav-item--active');
    });

    // Show selected tab
    const selectedTab = document.getElementById(tabName + '-tab');
    if (selectedTab) {
      selectedTab.style.display = 'block';
    }

    // Add active class to clicked nav item (matched via data-switch-tab="<name>")
    const clickedNavItem = document.querySelector('[data-switch-tab="' + tabName + '"]');
    if (clickedNavItem) {
      clickedNavItem.classList.add('customer-account__nav-item--active');
    }

    // Update nav dots
    const dots = document.querySelectorAll('.customer-account__nav-dot');
    dots.forEach(dot => {
      dot.style.background = 'transparent';
      dot.style.borderColor = 'var(--color-primary)';
    });

    const activeDot = clickedNavItem?.querySelector('.customer-account__nav-dot');
    if (activeDot) {
      activeDot.style.background = 'var(--color-primary-dark)';
      activeDot.style.borderColor = 'var(--color-primary-dark)';
    }
  };

  // Modal functions
  window.openAddressModal = function() {
    const modal = document.getElementById('add-address-modal');
    if (modal) {
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }
  };

  window.closeAddressModal = function() {
    const modal = document.getElementById('add-address-modal');
    if (modal) {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }
  };

  // Show the per-address edit modal that was rendered server-side by the
  // customer_address form tag. Server-rendered HTML keeps the
  // authenticity_token intact and avoids any client-side templating XSS.
  window.openEditModal = function(addressId) {
    const modal = document.getElementById('edit-address-modal-' + addressId);
    if (!modal) return;
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  };

  window.closeEditModal = function(addressId) {
    if (addressId) {
      const modal = document.getElementById('edit-address-modal-' + addressId);
      if (modal) modal.style.display = 'none';
    } else {
      document.querySelectorAll('[id^="edit-address-modal-"]').forEach((el) => {
        el.style.display = 'none';
      });
    }
    document.body.style.overflow = '';
  };

  // Delegated handlers installed once per session — Swup re-executes this
  // section script on every navigation back to the account page, so without
  // a guard each click would fire its handler N+1 times.
  if (!window.__customerAccountGlobalsInstalled) {
    window.__customerAccountGlobalsInstalled = true;

    document.addEventListener('click', function (e) {
      const target = e.target;
      if (!target || !target.closest) return;

      const editBtn = target.closest('[data-edit-address]');
      if (editBtn) {
        window.openEditModal(editBtn.getAttribute('data-edit-address'));
        return;
      }
      if (target.closest('[data-close-edit-modal]')) {
        window.closeEditModal();
        return;
      }

      const tabBtn = target.closest('[data-switch-tab]');
      if (tabBtn) {
        window.switchTab(tabBtn.getAttribute('data-switch-tab'));
        return;
      }
      if (target.closest('[data-open-address-modal]')) {
        window.openAddressModal();
        return;
      }
      if (target.closest('[data-close-address-modal]')) {
        window.closeAddressModal();
        return;
      }
      if (target.closest('[data-open-birthdate-modal]')) {
        window.openBirthdateModal();
        return;
      }
      if (target.closest('[data-close-birthdate-modal]')) {
        window.closeBirthdateModal();
        return;
      }
    });

    // Confirm-and-submit for the server-rendered delete form
    document.addEventListener('click', function (e) {
      const btn = e.target.closest && e.target.closest('[data-delete-address-confirm]');
      if (!btn) return;
      const msg = (window.theme && window.theme.accountStrings && window.theme.accountStrings.deleteAddressConfirm)
        || 'Are you sure you want to delete this address?';
      if (!confirm(msg)) {
        e.preventDefault();
      }
    });
  }

  window.openBirthdateModal = function() {
    const modal = document.getElementById('birthdate-modal');
    if (modal) {
      // Get current birth date from the info card
      const birthDateCard = document.querySelector('.customer-account__info-item--with-action .customer-account__info-value');
      let currentBirthDate = '';
      
      if (birthDateCard) {
        const birthDateText = birthDateCard.textContent.trim();
        if (birthDateText && birthDateText !== '—') {
          // Parse "September 11, 2025" format to "2025-09-11"
          try {
            const date = new Date(birthDateText);
            if (!isNaN(date.getTime())) {
              const year = date.getFullYear();
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const day = String(date.getDate()).padStart(2, '0');
              currentBirthDate = `${year}-${month}-${day}`;
            }
          } catch (e) {
            // Couldn't parse the displayed birth date; leave the field blank.
          }
        }
      }
      
      // Pre-fill the date input if we have a current value
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      
      // Wait for modal to be visible, then populate the date field
      setTimeout(() => {
        const dateInput = modal.querySelector('input[type="date"]');
        if (dateInput && currentBirthDate) {
          dateInput.value = currentBirthDate;
        }
      }, 50);
    }
  };

  window.closeBirthdateModal = function() {
    const modal = document.getElementById('birthdate-modal');
    if (modal) {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }
  };

  // Close modals when clicking outside or pressing escape. Guarded so
  // it isn't stacked on every Swup re-execution.
  if (!window.__customerAccountEscapeInstalled) {
    window.__customerAccountEscapeInstalled = true;
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeAddressModal();
        closeEditModal();
        closeBirthdateModal();
      }
    });
  }

  // Stubs in case the actual definitions failed to load — silent no-ops
  // rather than console spam on every click.
  window.openAddressModal = window.openAddressModal || function () {};
  window.closeAddressModal = window.closeAddressModal || function () {};
  window.openEditModal = window.openEditModal || function () {};
  window.closeEditModal = window.closeEditModal || function () {};
  window.openBirthdateModal = window.openBirthdateModal || function () {};
  window.closeBirthdateModal = window.closeBirthdateModal || function () {};
  window.switchTab = window.switchTab || function () {};

  // Run per page-view. SwupScriptsPlugin re-executes this section's JS on
  // every navigation that includes the section, so a single immediate call
  // is the page-view trigger — no swup:page:view listener needed (which
  // would double-init). DOMContentLoaded is only needed on the initial
  // load when this script ran before the body was parsed.
  function initCustomerAccountView() {
    initBirthdateForm();
    if (typeof window.switchTab === 'function') {
      window.switchTab('overview');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomerAccountView, { once: true });
  } else {
    initCustomerAccountView();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-addresses"]) return;
  try {
    
  function toggleAddressForm() {
    const form = document.getElementById('add-address-form');
    if (!form) return;
    if (form.style.display === 'none') {
      form.style.display = 'block';
      form.scrollIntoView({ behavior: 'smooth' });
    } else {
      form.style.display = 'none';
    }
  }

  // Delegated handlers installed once per session — Swup re-executes this
  // section script on every navigation back to /account/addresses.
  if (!window.__customerAddressesGlobalsInstalled) {
    window.__customerAddressesGlobalsInstalled = true;
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('[data-toggle-address-form]')) {
        toggleAddressForm();
        return;
      }
      const deleteBtn = e.target.closest('[data-delete-address-confirm]');
      if (deleteBtn) {
        const msg = (window.theme && window.theme.accountStrings && window.theme.accountStrings.deleteAddressConfirm)
          || 'Are you sure you want to delete this address?';
        if (!confirm(msg)) {
          e.preventDefault();
        }
      }
    });
  }

  // Re-binds the country/province <select> handler. SwupScriptsPlugin
  // re-executes this script on every navigation back to /account/addresses,
  // so a single immediate call is the page-view trigger.
  function bindCountryProvinceSelectors() {
    const countrySelect = document.getElementById('address_country');
    const provinceSelect = document.getElementById('address_province');
    if (countrySelect && provinceSelect) {
      countrySelect.addEventListener('change', function() {
        provinceSelect.innerHTML = '<option value="">Select State/Province</option>';
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindCountryProvinceSelectors, { once: true });
  } else {
    bindCountryProvinceSelectors();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-login"]) return;
  try {
    
  class CustomerLogin {
    constructor() {
      this.recoverToggles = document.querySelectorAll('[data-recover-toggle]');
      this.recoverForm = document.getElementById('recover');
      this.loginForm = document.querySelector('.customer-login__form-container');
      
      this.init();
    }

    init() {
      this.bindEvents();
    }

    bindEvents() {
      this.recoverToggles.forEach(toggle => {
        toggle.addEventListener('click', (e) => {
          e.preventDefault();
          this.toggleRecoverForm();
        });
      });
    }

    toggleRecoverForm() {
      const isRecoverVisible = this.recoverForm.style.display !== 'none';
      
      if (isRecoverVisible) {
        this.recoverForm.style.display = 'none';
        this.loginForm.style.display = 'block';
      } else {
        this.recoverForm.style.display = 'block';
        this.loginForm.style.display = 'none';
      }
    }
  }

  // SwupScriptsPlugin re-executes this script on every navigation back to
  // /account/login, so calling boot once is enough — no swup:page:view
  // listener needed. DOMContentLoaded handles the initial-load case where
  // the script runs before the body is parsed.
  function bootCustomerLogin() {
    if (document.querySelector('[data-recover-toggle]')) {
      new CustomerLogin();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootCustomerLogin, { once: true });
  } else {
    bootCustomerLogin();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Navigation logic moved to assets/theme.js

  } catch(e) { console.error(e); }
})();
})();
